import React from "react";
import { Button, Row, Col } from 'react-bootstrap';

const OptionsList = (props) => {
    let _class = `filter-benefits-button  mobile-filter-button`;
    let row = (<Row className='available-user-row'>
        {
            props.options.map((option) => (
                <Col className='user-tile' key={option.value} xs={12} sm={12}>
                    <Button onClick={props.onSelect} className={`${props.selectedOption === option.label ? 'selected-day-card' : ''} ${_class}`} > {option.label}</Button>
                </Col>
            ))}
    </Row>)
    return (row)
}

export default OptionsList;
